<script setup lang="ts">
import { inject } from "vue";
import { WatchlistService } from "../services/watchlist.service";
import { SITEURL } from "@libTs/cms.globals";
import { itemCodeToUrlSlug } from "../helpers/url.helper";
import { vClickOutside } from "../directives/v-click-outside";

const watchlistSvc = inject<WatchlistService>(
    "watchlistSvc",
) as WatchlistService;
</script>

<template>
    <div
        class="relative border-b-4 h-full flex items-center w-6 justify-center border-t-transparent border-t-4"
        :class="{
            'border-b-primary': watchlistSvc.openWatchlist,
            'border-b-transparent': !watchlistSvc.openWatchlist,
        }"
        v-click-outside="() => (watchlistSvc.openWatchlist = false)"
    >
        <button
            class="btn-pin"
            @click="watchlistSvc.openWatchlist = !watchlistSvc.openWatchlist"
            title="Watchlist"
        ></button>
        <div
            v-if="watchlistSvc.openWatchlist"
            class="absolute top-20 right-0 w-auto min-w-[400px] bg-white shadow-lg z-50 pt-8 pb-8 px-6"
        >
            <button
                @click="watchlistSvc.openWatchlist = false"
                class="absolute top-6 right-6 text-grey-500 hover:text-grey-700"
            >
                <i class="fal fa-times text-f3"></i>
            </button>
            <div
                class="pb-4 border-b border-grey-200 flex justify-between items-center"
            >
                <h3 class="text-f4 font-bold">Watchlist</h3>
            </div>
            <div v-if="watchlistSvc.list.length === 0" class="py-4">
                Your watchlist is empty.
            </div>
            <ul v-else class="">
                <li
                    v-for="(item, index) in watchlistSvc.list"
                    :key="index"
                    class="p-4 border-b border-grey-200 flex items-start last:border-b-0"
                >
                    <div class="flex items-start w-full gap-5">
                        <img
                            v-if="item.ImageURL"
                            :src="item.ImageURL"
                            alt="Item Image"
                            class="w-20 h-11 object-contain mr-4 rounded-sm shrink-0 grow-0"
                        />
                        <div
                            class="bg-grey-30 rounded-sm w-20 h-11 mr-4 flex items-center justify-center shrink-0 grow-0"
                            v-else
                        >
                            <img
                                :src="SITEURL + 'assets/icons/no-photo.svg'"
                                alt="No Image Available"
                                class="w-4 h-4 object-contain"
                            />
                        </div>
                        <a
                            :href="'/product/' + itemCodeToUrlSlug(item.ItemCode)"
                            class="flex-grow"
                        >
                            <h4
                                class="text-f6 font-bold break-word hyphens-auto"
                            >
                                {{ item.ItemName }}
                            </h4>
                        </a>
                        <button
                            class=""
                            @click.stop="watchlistSvc.remove(item)"
                        >
                            <i class="far fa-trash"></i>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
